import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import {
  AppBar,
  Box,
  CssBaseline,
  Drawer,
  IconButton,
  Toolbar,
  Typography,
  ThemeProvider,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { customTheme } from './theme';
import { pages } from './routes';
import NavigationDrawer from './components/NavigationDrawer';

const drawerWidth = 240;

const App: React.FC = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = () => setMobileOpen((open) => !open);

  return (
    <ThemeProvider theme={customTheme}>
      <Router>
        <Box sx={{ display: 'flex', minHeight: '100vh' }}>
          <CssBaseline />
          {/* <AppBar position="fixed" color="primary" sx={{ zIndex: (t: any) => t.zIndex.drawer + 1 }}> */}
          <AppBar
  position="fixed"
  sx={{
    zIndex: (t) => t.zIndex.drawer + 1,
    background: 'linear-gradient(98.72deg, rgb(29, 202, 155) 9.24%, rgb(29, 202, 36) 87.42%)'
  }}
>
            <Toolbar>
              {!isDesktop && (
                <IconButton color="inherit" edge="start" onClick={handleDrawerToggle} sx={{ mr: 2 }}>
                  <MenuIcon />
                </IconButton>
              )}
              <Box
                component={Link}
                to="/"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  flexGrow: 1,
                  textDecoration: 'none',
                  color: 'inherit'
                }}
              >
                <Box
                  component="img"
                  src="/logo192.png"
                  alt="Logo"
                  sx={{ height: 32, mr: 1 }}
                />
                <Typography variant="h6" noWrap>
                  Handprint API Demo
                </Typography>
              </Box>
              {/* <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>Handprint API Demo</Typography> */}
            </Toolbar>
          </AppBar>
          <Box component="nav" sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}>
            <Drawer
              variant={isDesktop ? 'permanent' : 'temporary'}
              open={isDesktop || mobileOpen}
              onClose={handleDrawerToggle}
              ModalProps={{ keepMounted: true }}
              sx={{ '& .MuiDrawer-paper': { width: drawerWidth, top: '56px' } }}
            >
              <NavigationDrawer isDesktop={isDesktop} handleDrawerToggle={handleDrawerToggle} />
            </Drawer>
          </Box>
          <Box component="main" sx={{ flexGrow: 1, p: 3, mt: '64px', width: { sm: `calc(100% - ${drawerWidth}px)` }, backgroundColor: 'background.default' }}>
            <Routes>
              {pages.map(({ path, element }) => (
                <Route key={path} path={path} element={element} />
              ))}
            </Routes>
          </Box>
        </Box>
      </Router>
    </ThemeProvider>
  );
};

export default App;
